import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import useSmall from '../../../hooks/useSmall';

const TabPanel = props => {
  const { children, value, index, ...other } = props;
  const isMobile = useSmall();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, px: isMobile ? 0 : 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default TabPanel;
